const resList = [
    {
      "type": "restaurant",
      "info": {
        "resId": 20468788,
        "name": "The Bagh Gourmet Garden & Bar",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/8/20468788/07ea7234fe8562d098dfe936d8b2468d_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/8/20468788/07ea7234fe8562d098dfe936d8b2468d_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": false
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "4.4",
          "rating_text": "4.4",
          "rating_subtitle": "Very Good",
          "rating_color": "5BA829",
          "votes": "134",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "4.4",
              "reviewCount": "134",
              "reviewTextSmall": "134 Reviews",
              "subtext": "134 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "4.4",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "",
              "reviewCount": "0",
              "reviewTextSmall": "0 Reviews",
              "subtext": "Does not offer Delivery",
              "color": "",
              "ratingV2": "-",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "100"
              },
              "textColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,500 for two"
        },
        "cfo": {
          "text": "₹600 for one"
        },
        "locality": {
          "name": "Maquboolpura, Amritsar",
          "address": "Verka Vallah Bypass Road, Maquboolpura, Amritsar",
          "localityUrl": "amritsar/maquboolpura-restaurants"
        },
        "timing": {
          "text": "Opens at 12:30pm",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/asian/",
            "name": "Asian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/mediterranean/",
            "name": "Mediterranean"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/cafes/",
            "name": "Cafe"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/thai/",
            "name": "Thai"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,500 for two"
        }
      },
      "order": [],
      "gold": [],
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/the-bagh-gourmet-garden-bar-maquboolpura/info",
        "clickActionDeeplink": ""
      },
      "distance": "6.3 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"7469279\",\"bzone\":\"0\",\"campaign_id\":\"16437876\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20468788\",\"isNewAd\":\"109\",\"ad_position\":\"10\",\"slider_position\":\"10\",\"slider_sequence\":\"10\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":6,\\\"boosted_rank\\\":10,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.144644\\\",\\\"distance\\\":\\\"5.904658317565918\\\",\\\"organic_ctr\\\":\\\"0.044232\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"1739\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"1\\\",\\\"cost_per_unit\\\":\\\"0.08122270742358077\\\",\\\"distance\\\":\\\"0.22114005723403668\\\",\\\"organic_ctr\\\":\\\"1\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.2238514173998045\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.40641141274305376}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20468788\",\"element_type\":\"listing\",\"rank\":10,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 20885412,
        "name": "Cafe Delhi Heights",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/2/20885412/b6fe3bb584ca1c0db9bbedd0d71b4d9d_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/2/20885412/b6fe3bb584ca1c0db9bbedd0d71b4d9d_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/2/20885412/5881c7d73a12f822f518b7596caa7ffe_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "4.4",
          "rating_text": "4.4",
          "rating_subtitle": "Very Good",
          "rating_color": "5BA829",
          "votes": "860",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "4.6",
              "reviewCount": "557",
              "reviewTextSmall": "557 Reviews",
              "subtext": "557 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "4.6",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "800"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "4.1",
              "reviewCount": "303",
              "reviewTextSmall": "303 Reviews",
              "subtext": "303 Delivery Reviews",
              "color": "#E23744",
              "ratingV2": "4.1",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,500 for two"
        },
        "cfo": {
          "text": "₹600 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "SCO 59, B Block, District Shopping Complex, Kathu Nangal, Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 12noon",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/italian/",
            "name": "Italian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,500 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 15,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "15% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/cafe-delhi-heights-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "1.8 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"8629787\",\"bzone\":\"0\",\"campaign_id\":\"17605217\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20885412\",\"isNewAd\":\"34\",\"ad_position\":\"11\",\"slider_position\":\"11\",\"slider_sequence\":\"11\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":10,\\\"boosted_rank\\\":11,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.042934\\\",\\\"cost_for_two_ctr\\\":\\\"0.099351\\\",\\\"distance\\\":\\\"1.8962045907974243\\\",\\\"organic_ctr\\\":\\\"0.021432\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"136\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.6808112522398237\\\",\\\"cost_for_two_ctr\\\":\\\"0.6153460721868365\\\",\\\"cost_per_unit\\\":\\\"0\\\",\\\"distance\\\":\\\"0.8497458477207017\\\",\\\"organic_ctr\\\":\\\"0.39269637482353564\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.38532029367422466}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20885412\",\"element_type\":\"listing\",\"rank\":11,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 2200483,
        "name": "EatAsia Food",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/3/2200483/e9df87b22c9d16652c427e857711c193_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/2200483/e9df87b22c9d16652c427e857711c193_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/3/2200483/6d5ad7d3ef7785f035f8a84f32d92896_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "4.3",
          "rating_text": "4.3",
          "rating_subtitle": "Very Good",
          "rating_color": "5BA829",
          "votes": "18.6K",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "4.4",
              "reviewCount": "551",
              "reviewTextSmall": "551 Reviews",
              "subtext": "551 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "4.4",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "4.2",
              "reviewCount": "18.1K",
              "reviewTextSmall": "18.1K Reviews",
              "subtext": "18.1K Delivery Reviews",
              "color": "#E23744",
              "ratingV2": "4.2",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹700 for two"
        },
        "cfo": {
          "text": "₹300 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "C Block Market, Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 11am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/south-indian/",
            "name": "South Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/maharashtrian/",
            "name": "Maharashtrian"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹700 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/eatasia-food-1-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "2 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"7926988\",\"bzone\":\"0\",\"campaign_id\":\"16899537\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"2200483\",\"isNewAd\":\"109\",\"ad_position\":\"12\",\"slider_position\":\"12\",\"slider_sequence\":\"12\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":88,\\\"boosted_rank\\\":12,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.026894\\\",\\\"distance\\\":\\\"2.075814962387085\\\",\\\"organic_ctr\\\":\\\"0.021207\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"2232\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.05065502183406113\\\",\\\"distance\\\":\\\"0.8215793457953464\\\",\\\"organic_ctr\\\":\\\"0.3867032469435048\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.2926965507610669\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.30726025930989886}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2200483\",\"element_type\":\"listing\",\"rank\":12,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 21128269,
        "name": "Machhiwala By Makhan Fish Company",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/9/21128269/01dda6531598ed570fa753f404e49868_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/21128269/01dda6531598ed570fa753f404e49868_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/9/21128269/23f478209b3353199cfecec2f71cc622_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "4.4",
          "rating_text": "4.4",
          "rating_subtitle": "Very Good",
          "rating_color": "5BA829",
          "votes": "568",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "4.5",
              "reviewCount": "97",
              "reviewTextSmall": "97 Reviews",
              "subtext": "97 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "4.5",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "800"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "4.2",
              "reviewCount": "471",
              "reviewTextSmall": "471 Reviews",
              "subtext": "471 Delivery Reviews",
              "color": "#E23744",
              "ratingV2": "4.2",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,300 for two"
        },
        "cfo": {
          "text": "₹550 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "310, Green Avenue, Near Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 11:30am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/sea-food/",
            "name": "Seafood"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/biryani/",
            "name": "Biryani"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/asian/",
            "name": "Asian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/pizza/",
            "name": "Pizza"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/italian/",
            "name": "Italian"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,300 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/machhiwala-by-makhan-fish-company-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "1.2 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"8761090\",\"bzone\":\"0\",\"campaign_id\":\"17736554\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"21128269\",\"isNewAd\":\"109\",\"ad_position\":\"13\",\"slider_position\":\"13\",\"slider_sequence\":\"13\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":21,\\\"boosted_rank\\\":13,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.058998\\\",\\\"distance\\\":\\\"1.2617383003234863\\\",\\\"organic_ctr\\\":\\\"0.018957\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"7297\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.2726454352441614\\\",\\\"cost_per_unit\\\":\\\"0.05065502183406113\\\",\\\"distance\\\":\\\"0.9492428635892215\\\",\\\"organic_ctr\\\":\\\"0.3267719681431958\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"1\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.29287272983420815}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"21128269\",\"element_type\":\"listing\",\"rank\":13,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 20989374,
        "name": "Diora Multicuisine Restaurant",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/4/20989374/77f5089e1307cf6d690bcd90993f83ba_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/4/20989374/77f5089e1307cf6d690bcd90993f83ba_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/4/20989374/75794847c4bfe24a6a7c1aa0e59ee353_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "3.9",
          "rating_text": "3.9",
          "rating_subtitle": "Good",
          "rating_color": "9ACD32",
          "votes": "87",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "3.8",
              "reviewCount": "58",
              "reviewTextSmall": "58 Reviews",
              "subtext": "58 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "3.8",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "600"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "4.0",
              "reviewCount": "29",
              "reviewTextSmall": "29 Reviews",
              "subtext": "29 Delivery Reviews",
              "color": "#E23744",
              "ratingV2": "4.0",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹2,100 for two"
        },
        "cfo": {
          "text": "₹850 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "74, 6th Floor, D Block, Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 2pm",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/mughlai/",
            "name": "Mughlai"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/italian/",
            "name": "Italian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/asian/",
            "name": "Asian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/biryani/",
            "name": "Biryani"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/beverages/",
            "name": "Beverages"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹2,100 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 15,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "15% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/diora-multicuisine-restaurant-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "1.7 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"7781250\",\"bzone\":\"0\",\"campaign_id\":\"16752119\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20989374\",\"isNewAd\":\"109\",\"ad_position\":\"14\",\"slider_position\":\"14\",\"slider_sequence\":\"14\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":29,\\\"boosted_rank\\\":14,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.06398\\\",\\\"distance\\\":\\\"1.8978348970413208\\\",\\\"organic_ctr\\\":\\\"0.020784\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"1651\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.3149554140127388\\\",\\\"cost_per_unit\\\":\\\"0.05065502183406113\\\",\\\"distance\\\":\\\"0.8494901830641943\\\",\\\"organic_ctr\\\":\\\"0.3754361665290467\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.21156263091746963\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.28773068574873156}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20989374\",\"element_type\":\"listing\",\"rank\":14,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 20903383,
        "name": "Casa Artesa",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/3/20903383/f81ed5e6b833a5daf2d280aa63f1ccbf_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/20903383/f81ed5e6b833a5daf2d280aa63f1ccbf_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/3/20903383/e6a59ab9e6cdeabe62d25308d06aa489_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "3.9",
          "rating_text": "3.9",
          "rating_subtitle": "Good",
          "rating_color": "9ACD32",
          "votes": "55",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "3.9",
              "reviewCount": "55",
              "reviewTextSmall": "55 Reviews",
              "subtext": "55 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "3.9",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "600"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "",
              "reviewCount": "0",
              "reviewTextSmall": "0 Reviews",
              "subtext": "Does not offer Delivery",
              "color": "",
              "ratingV2": "-",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "100"
              },
              "textColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,800 for two"
        },
        "cfo": {
          "text": "₹750 for one"
        },
        "locality": {
          "name": "Amritsar Cantonment, Amritsar",
          "address": "Plot 11, Palm Groove, Club Lane, Airport Road, Amritsar Cantonment, Amritsar",
          "localityUrl": "amritsar/amritsar-cantonment-restaurants"
        },
        "timing": {
          "text": "Opens at 11:30am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjI3XCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/bar-food/",
            "name": "Bar Food"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/pizza/",
            "name": "Pizza"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/italian/",
            "name": "Italian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/coffee/",
            "name": "Coffee"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,800 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 15,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "15% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/casa-artesa-amritsar-cantonment/info",
        "clickActionDeeplink": ""
      },
      "distance": "7 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"7481043\",\"bzone\":\"0\",\"campaign_id\":\"16449850\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20903383\",\"isNewAd\":\"109\",\"ad_position\":\"15\",\"slider_position\":\"15\",\"slider_sequence\":\"15\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":18,\\\"boosted_rank\\\":15,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.118726\\\",\\\"distance\\\":\\\"7.314810276031494\\\",\\\"organic_ctr\\\":\\\"0.024823\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"5699\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.7798895966029724\\\",\\\"cost_per_unit\\\":\\\"0.05065502183406113\\\",\\\"distance\\\":\\\"0\\\",\\\"organic_ctr\\\":\\\"0.48301947100657916\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.7768468091048736\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.2805596077395727}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20903383\",\"element_type\":\"listing\",\"rank\":15,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 21607824,
        "name": "Chef's Theory",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/4/21607824/e10c05a48c9c7a0f40e44eb24a40299e_o2_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/4/21607824/e10c05a48c9c7a0f40e44eb24a40299e_o2_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/4/21607824/e10c05a48c9c7a0f40e44eb24a40299e_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "3.7",
          "rating_text": "3.7",
          "rating_subtitle": "Good",
          "rating_color": "9ACD32",
          "votes": "13",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "3.7",
              "reviewCount": "9",
              "reviewTextSmall": "9 Reviews",
              "subtext": "9 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "3.7",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "",
              "reviewCount": "4",
              "reviewTextSmall": "4 Reviews",
              "subtext": "Does not offer Delivery",
              "color": "",
              "ratingV2": "-",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "100"
              },
              "textColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,000 for two"
        },
        "cfo": {
          "text": "₹400 for one"
        },
        "locality": {
          "name": "White Avenue, Amritsar",
          "address": "52-A, Rose Avenue, Ratan Chand Road, Near White Avenue, Amritsar",
          "localityUrl": "amritsar/white-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 7am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/biryani/",
            "name": "Biryani"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjc4XCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/oriental/",
            "name": "Oriental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/pizza/",
            "name": "Pizza"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/fast-food/",
            "name": "Fast Food"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/salad/",
            "name": "Salad"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,000 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/chefs-theory-white-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "1.2 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"8636873\",\"bzone\":\"0\",\"campaign_id\":\"17612306\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"21607824\",\"isNewAd\":\"109\",\"ad_position\":\"16\",\"slider_position\":\"16\",\"slider_sequence\":\"16\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":2,\\\"boosted_rank\\\":16,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.038462\\\",\\\"distance\\\":\\\"0.9380733966827393\\\",\\\"organic_ctr\\\":\\\"0.016129\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"5292\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.59\\\",\\\"distance\\\":\\\"1\\\",\\\"organic_ctr\\\":\\\"0.6029252091716165\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.8579274990845844\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"more\\\",\\\"total_score\\\":0.49952382611325774}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"21607824\",\"element_type\":\"listing\",\"rank\":16,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 2200584,
        "name": "Kava Grill & Lounge - Fairfield By Marriott",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/4/2200584/d305d881f37372033f883ed1f49ea9b5_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/4/2200584/d305d881f37372033f883ed1f49ea9b5_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/4/2200584/d15024c13458e3aa5552c37292bc304d_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "4.7",
          "rating_text": "4.7",
          "rating_subtitle": "Excellent",
          "rating_color": "3F7E00",
          "votes": "616",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "4.7",
              "reviewCount": "615",
              "reviewTextSmall": "615 Reviews",
              "subtext": "615 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "4.7",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "800"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "",
              "reviewCount": "1",
              "reviewTextSmall": "1 Reviews",
              "subtext": "Does not offer Delivery",
              "color": "",
              "ratingV2": "-",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "100"
              },
              "textColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹3,000 for two"
        },
        "cfo": {
          "text": "₹1,200 for one"
        },
        "locality": {
          "name": "INA Colony, Amritsar",
          "address": "Albert Road, INA Colony, Amritsar",
          "localityUrl": "amritsar/ina-colony-restaurants"
        },
        "timing": {
          "text": "Opens at 7am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/asian/",
            "name": "Asian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/biryani/",
            "name": "Biryani"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/thai/",
            "name": "Thai"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/beverages/",
            "name": "Beverages"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹3,000 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 30,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "30% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/kava-grill-lounge-fairfield-by-marriott-ina-colony/info",
        "clickActionDeeplink": ""
      },
      "distance": "782 m",
      "isPromoted": false,
      "promotedText": "",
      "trackingData": [
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2200584\",\"element_type\":\"listing\",\"rank\":17}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 2200642,
        "name": "The BrewMaster",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/2/2200642/c7694a542294a63a944b6fb29bf10728_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/2/2200642/c7694a542294a63a944b6fb29bf10728_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/2/2200642/03f3cca98820abf5d889648fa6657c2c_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "4.4",
          "rating_text": "4.4",
          "rating_subtitle": "Very Good",
          "rating_color": "5BA829",
          "votes": "505",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "4.7",
              "reviewCount": "216",
              "reviewTextSmall": "216 Reviews",
              "subtext": "216 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "4.7",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "800"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "4.1",
              "reviewCount": "289",
              "reviewTextSmall": "289 Reviews",
              "subtext": "289 Delivery Reviews",
              "color": "#E23744",
              "ratingV2": "4.1",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,400 for two"
        },
        "cfo": {
          "text": "₹600 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "SCO-97, B Block, Ranjeet Avenue, Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 11am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/asian/",
            "name": "Asian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjc4XCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/oriental/",
            "name": "Oriental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/pizza/",
            "name": "Pizza"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,400 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/the-brewmaster-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "2 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"7568949\",\"bzone\":\"0\",\"campaign_id\":\"16538386\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"2200642\",\"isNewAd\":\"109\",\"ad_position\":\"18\",\"slider_position\":\"18\",\"slider_sequence\":\"18\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":25,\\\"boosted_rank\\\":18,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.063454\\\",\\\"distance\\\":\\\"2.095642328262329\\\",\\\"organic_ctr\\\":\\\"0.022346\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"2949\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"1\\\",\\\"cost_per_unit\\\":\\\"0.59\\\",\\\"distance\\\":\\\"0.06787335876499646\\\",\\\"organic_ctr\\\":\\\"1\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"more\\\",\\\"total_score\\\":0.4520746695114872}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2200642\",\"element_type\":\"listing\",\"rank\":18,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 20804174,
        "name": "Le Grand Cafe - Le Méridien",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/4/20804174/0b0222be17ece51aeb7639fe86e95772_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/4/20804174/0b0222be17ece51aeb7639fe86e95772_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": false
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "4.3",
          "rating_text": "4.3",
          "rating_subtitle": "Very Good",
          "rating_color": "5BA829",
          "votes": "88",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "4.3",
              "reviewCount": "88",
              "reviewTextSmall": "88 Reviews",
              "subtext": "88 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "4.3",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "",
              "reviewCount": "0",
              "reviewTextSmall": "0 Reviews",
              "subtext": "Does not offer Delivery",
              "color": "",
              "ratingV2": "-",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "100"
              },
              "textColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,800 for two"
        },
        "cfo": {
          "text": "₹750 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "SGRDJ International Airport, Ajnala Road, Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 6:30am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/cafes/",
            "name": "Cafe"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/asian/",
            "name": "Asian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTQzXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/health-food/",
            "name": "Healthy Food"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjc4XCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/oriental/",
            "name": "Oriental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/italian/",
            "name": "Italian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/beverages/",
            "name": "Beverages"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,800 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/le-grand-cafe-le-méridien-1-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "8.1 km",
      "isPromoted": false,
      "promotedText": "",
      "trackingData": [
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20804174\",\"element_type\":\"listing\",\"rank\":19}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 19348430,
        "name": "Egyptian Brewery",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/0/19348430/a33c044328d46a27e0594feffb7a1cfd_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/19348430/a33c044328d46a27e0594feffb7a1cfd_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": "https://b.zmtcdn.com/data/pictures/0/19348430/3067e029dad82fa70e703a82260ef829_o2_featured_v2.jpg"
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "3.9",
          "rating_text": "3.9",
          "rating_subtitle": "Good",
          "rating_color": "9ACD32",
          "votes": "623",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "3.7",
              "reviewCount": "145",
              "reviewTextSmall": "145 Reviews",
              "subtext": "145 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "3.7",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "4.0",
              "reviewCount": "478",
              "reviewTextSmall": "478 Reviews",
              "subtext": "478 Delivery Reviews",
              "color": "#E23744",
              "ratingV2": "4.0",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "700"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,000 for two"
        },
        "cfo": {
          "text": "₹400 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "SCO 12-13, District Shopping Complex, Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 12noon",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
            "name": "Chinese"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/italian/",
            "name": "Italian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/asian/",
            "name": "Asian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/beverages/",
            "name": "Beverages"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,000 for two"
        }
      },
      "order": [],
      "gold": {
        "instant": 15,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "15% OFF",
        "isGoldIcon": false
      },
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/egyptian-brewery-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "1.2 km",
      "isPromoted": true,
      "promotedText": "Promoted",
      "trackingData": [
        {
          "table_name": "jadtracking",
          "payload": "{\"banner_id\":\"7570386\",\"bzone\":\"0\",\"campaign_id\":\"16539823\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"19348430\",\"isNewAd\":\"109\",\"ad_position\":\"20\",\"slider_position\":\"20\",\"slider_sequence\":\"20\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":44,\\\"boosted_rank\\\":20,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.048706\\\",\\\"distance\\\":\\\"1.2974233627319336\\\",\\\"organic_ctr\\\":\\\"0.009783\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"4523\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.4098911651728553\\\",\\\"cost_per_unit\\\":\\\"0.59\\\",\\\"distance\\\":\\\"0.7106352220214909\\\",\\\"organic_ctr\\\":\\\"0.1976112920738328\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.5763456609300622\\\"},\\\"search_id\\\":\\\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\\\",\\\"section_name\\\":\\\"more\\\",\\\"total_score\\\":0.3740889554061878}\",\"subzone_id\":\"0\"}",
          "event_names": {
            "tap": "{\"action\":\"click\"}",
            "impression": "{\"action\":\"impression\"}",
            "served": "{\"action\":\"serve\"}"
          }
        },
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19348430\",\"element_type\":\"listing\",\"rank\":20,\"metadata\":{\"is_ad\":\"true\"}}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
      "type": "restaurant",
      "info": {
        "resId": 19294506,
        "name": "WelcomCafe Phulkari - WelcomHotel By ITC Hotels Amritsar",
        "image": {
          "url": "https://b.zmtcdn.com/data/pictures/6/19294506/ce1e9e5fad5ab82c88d9468739cb7916_featured_v2.jpg",
          "urlWithParams": "https://b.zmtcdn.com/data/pictures/6/19294506/ce1e9e5fad5ab82c88d9468739cb7916_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
          "url": false
        },
        "rating": {
          "has_fake_reviews": 0,
          "aggregate_rating": "3.9",
          "rating_text": "3.9",
          "rating_subtitle": "Good",
          "rating_color": "9ACD32",
          "votes": "24",
          "subtext": "REVIEWS",
          "is_new": false
        },
        "ratingNew": {
          "newlyOpenedObj": null,
          "suspiciousReviewObj": null,
          "ratings": {
            "DINING": {
              "rating_type": "DINING",
              "rating": "3.9",
              "reviewCount": "24",
              "reviewTextSmall": "24 Reviews",
              "subtext": "24 Dining Reviews",
              "color": "#1C1C1C",
              "ratingV2": "3.9",
              "subtitle": "DINING",
              "sideSubTitle": "Dining Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "600"
              },
              "newOnDining": false
            },
            "DELIVERY": {
              "rating_type": "DELIVERY",
              "rating": "",
              "reviewCount": "0",
              "reviewTextSmall": "0 Reviews",
              "subtext": "Does not offer Delivery",
              "color": "",
              "ratingV2": "-",
              "subtitle": "DELIVERY",
              "sideSubTitle": "Delivery Ratings",
              "bgColorV2": {
                "type": "green",
                "tint": "100"
              },
              "textColorV2": {
                "type": "green",
                "tint": "500"
              },
              "newOnDelivery": false
            }
          }
        },
        "cft": {
          "text": "₹1,000 for two"
        },
        "cfo": {
          "text": "₹400 for one"
        },
        "locality": {
          "name": "Ranjit Avenue, Amritsar",
          "address": "WelcomHotel, Raja Sansi, Ajnala Road, Amritsar, Ranjit Avenue, Amritsar",
          "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
          "text": "Opens at 7am",
          "color": "#ab000d"
        },
        "cuisine": [
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/continental/",
            "name": "Continental"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/italian/",
            "name": "Italian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
            "name": "North Indian"
          },
          {
            "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            "url": "https://www.zomato.com/amritsar/restaurants/desserts/",
            "name": "Desserts"
          }
        ],
        "should_ban_ugc": false,
        "costText": {
          "text": "₹1,000 for two"
        }
      },
      "order": [],
      "gold": [],
      "takeaway": [],
      "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/welcomcafe-phulkari-welcomhotel-by-itc-hotels-amritsar-ranjit-avenue/info",
        "clickActionDeeplink": ""
      },
      "distance": "10.5 km",
      "isPromoted": false,
      "promotedText": "",
      "trackingData": [
        {
          "table_name": "zsearch_events_log",
          "payload": "{\"search_id\":\"96857ba2-a1fa-4a27-ac87-d63655a70b5a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19294506\",\"element_type\":\"listing\",\"rank\":21}",
          "event_names": {
            "tap": "{\"action\":\"tap\"}",
            "impression": "{\"action\":\"impression\"}"
          }
        }
      ],
      "allCTA": [],
      "promoOffer": "",
      "checkBulkOffers": false,
      "bulkOffers": [],
      "isDisabled": false,
      "bottomContainers": []
    },
    {
    "type": "restaurant",
    "info": {
        "resId": 21364497,
        "name": "Shiso - Modern Asian Kitchen and Bar",
        "image": {
            "url": "https://b.zmtcdn.com/data/pictures/7/21364497/e4ceb3ac24eaa5da2e2e44e53ed88b46_featured_v2.jpg",
            "urlWithParams": "https://b.zmtcdn.com/data/pictures/7/21364497/e4ceb3ac24eaa5da2e2e44e53ed88b46_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
            "url": false
        },
        "rating": {
            "has_fake_reviews": 0,
            "aggregate_rating": "4.5",
            "rating_text": "4.5",
            "rating_subtitle": "Excellent",
            "rating_color": "3F7E00",
            "votes": "51",
            "subtext": "REVIEWS",
            "is_new": false
        },
        "ratingNew": {
            "newlyOpenedObj": null,
            "suspiciousReviewObj": null,
            "ratings": {
                "DINING": {
                    "rating_type": "DINING",
                    "rating": "4.5",
                    "reviewCount": "51",
                    "reviewTextSmall": "51 Reviews",
                    "subtext": "51 Dining Reviews",
                    "color": "#1C1C1C",
                    "ratingV2": "4.5",
                    "subtitle": "DINING",
                    "sideSubTitle": "Dining Ratings",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "800"
                    },
                    "newOnDining": false
                },
                "DELIVERY": {
                    "rating_type": "DELIVERY",
                    "rating": "",
                    "reviewCount": "0",
                    "reviewTextSmall": "0 Reviews",
                    "subtext": "Does not offer Delivery",
                    "color": "",
                    "ratingV2": "-",
                    "subtitle": "DELIVERY",
                    "sideSubTitle": "Delivery Ratings",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "100"
                    },
                    "textColorV2": {
                        "type": "green",
                        "tint": "500"
                    },
                    "newOnDelivery": false
                }
            }
        },
        "cft": {
            "text": "₹2,500 for two"
        },
        "cfo": {
            "text": "₹1,000 for one"
        },
        "locality": {
            "name": "Majitha Road, Amritsar",
            "address": "Shashtri nagar, Majitha Verka By pass, Majitha Road, Amritsar, Punjab",
            "localityUrl": "amritsar/majitha-road-restaurants"
        },
        "timing": {
            "text": "Opens at 12:30pm",
            "color": "#ab000d"
        },
        "cuisine": [
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/asian/",
                "name": "Asian"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/continental/",
                "name": "Continental"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxOFwiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/modern-indian/",
                "name": "Modern Indian"
            }
        ],
        "should_ban_ugc": false,
        "costText": {
            "text": "₹2,500 for two"
        }
    },
    "order": [],
    "gold": [],
    "takeaway": [],
    "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/shiso-modern-asian-kitchen-and-bar-majitha-road/info",
        "clickActionDeeplink": ""
    },
    "distance": "5.5 km",
    "isPromoted": true,
    "promotedText": "Promoted",
    "trackingData": [
        {
            "table_name": "jadtracking",
            "payload": "{\"banner_id\":\"8693990\",\"bzone\":\"0\",\"campaign_id\":\"17669433\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"21364497\",\"isNewAd\":\"34\",\"ad_position\":\"10\",\"slider_position\":\"10\",\"slider_sequence\":\"10\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":40,\\\"boosted_rank\\\":10,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.049145\\\",\\\"cost_for_two_ctr\\\":\\\"0.097546\\\",\\\"distance\\\":\\\"5.294987678527832\\\",\\\"organic_ctr\\\":\\\"0.035075\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"707\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.8286682629076316\\\",\\\"cost_for_two_ctr\\\":\\\"0.6418539219041102\\\",\\\"cost_per_unit\\\":\\\"0.9947598253275108\\\",\\\"distance\\\":\\\"0.3216704056449203\\\",\\\"organic_ctr\\\":\\\"0.86964324391225\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.08741975140008196\\\"},\\\"search_id\\\":\\\"57b9b697-42d1-4147-9448-3aeffb6fddb5\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.43819693065668486}\",\"subzone_id\":\"0\"}",
            "event_names": {
                "tap": "{\"action\":\"click\"}",
                "impression": "{\"action\":\"impression\"}",
                "served": "{\"action\":\"serve\"}"
            }
        },
        {
            "table_name": "zsearch_events_log",
            "payload": "{\"search_id\":\"57b9b697-42d1-4147-9448-3aeffb6fddb5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"21364497\",\"element_type\":\"listing\",\"rank\":10,\"metadata\":{\"is_ad\":\"true\"}}",
            "event_names": {
                "tap": "{\"action\":\"tap\"}",
                "impression": "{\"action\":\"impression\"}"
            }
        }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": false,
    "bulkOffers": [],
    "isDisabled": false,
    "bottomContainers": []
    },
    {
    "type": "restaurant",
    "info": {
        "resId": 20972398,
        "name": "Kohi",
        "image": {
            "url": "https://b.zmtcdn.com/data/pictures/8/20972398/b74625280bb1258b066d0d17be961a56_featured_v2.jpg",
            "urlWithParams": "https://b.zmtcdn.com/data/pictures/8/20972398/b74625280bb1258b066d0d17be961a56_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
            "url": "https://b.zmtcdn.com/data/pictures/8/20972398/b40a11766b3a3087f88db2795cc28d44_o2_featured_v2.jpg"
        },
        "rating": {
            "has_fake_reviews": 0,
            "aggregate_rating": "4.2",
            "rating_text": "4.2",
            "rating_subtitle": "Very Good",
            "rating_color": "5BA829",
            "votes": "132",
            "subtext": "REVIEWS",
            "is_new": false
        },
        "ratingNew": {
            "newlyOpenedObj": null,
            "suspiciousReviewObj": null,
            "ratings": {
                "DINING": {
                    "rating_type": "DINING",
                    "rating": "4.2",
                    "reviewCount": "132",
                    "reviewTextSmall": "132 Reviews",
                    "subtext": "132 Dining Reviews",
                    "color": "#1C1C1C",
                    "ratingV2": "4.2",
                    "subtitle": "DINING",
                    "sideSubTitle": "Dining Ratings",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "700"
                    },
                    "newOnDining": false
                },
                "DELIVERY": {
                    "rating_type": "DELIVERY",
                    "rating": "",
                    "reviewCount": "0",
                    "reviewTextSmall": "0 Reviews",
                    "subtext": "Does not offer Delivery",
                    "color": "",
                    "ratingV2": "-",
                    "subtitle": "DELIVERY",
                    "sideSubTitle": "Delivery Ratings",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "100"
                    },
                    "textColorV2": {
                        "type": "green",
                        "tint": "500"
                    },
                    "newOnDelivery": false
                }
            }
        },
        "cft": {
            "text": "₹800 for two"
        },
        "cfo": {
            "text": "₹350 for one"
        },
        "locality": {
            "name": "Ranjit Avenue, Amritsar",
            "address": "43, D/Block, Gumtala, Ranjit Avenue, Amritsar",
            "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
            "text": "Opens at 11am",
            "color": "#ab000d"
        },
        "cuisine": [
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/cafes/",
                "name": "Cafe"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/coffee/",
                "name": "Coffee"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/pizza/",
                "name": "Pizza"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/pasta/",
                "name": "Pasta"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
                "url": "https://www.zomato.com/amritsar/restaurants/sandwich/",
                "name": "Sandwich"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                "url": "https://www.zomato.com/amritsar/restaurants/burger/",
                "name": "Burger"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/fast-food/",
                "name": "Fast Food"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NlwiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/shake/",
                "name": "Shake"
            }
        ],
        "should_ban_ugc": false,
        "costText": {
            "text": "₹800 for two"
        }
    },
    "order": [],
    "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
    },
    "takeaway": [],
    "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/kohi-ranjit-avenue/info",
        "clickActionDeeplink": ""
    },
    "distance": "2 km",
    "isPromoted": true,
    "promotedText": "Promoted",
    "trackingData": [
        {
            "table_name": "jadtracking",
            "payload": "{\"banner_id\":\"8926282\",\"bzone\":\"0\",\"campaign_id\":\"17902069\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20972398\",\"isNewAd\":\"34\",\"ad_position\":\"11\",\"slider_position\":\"11\",\"slider_sequence\":\"11\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":58,\\\"boosted_rank\\\":11,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.043822\\\",\\\"cost_for_two_ctr\\\":\\\"0.057724\\\",\\\"distance\\\":\\\"2.202336311340332\\\",\\\"organic_ctr\\\":\\\"0.028436\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"767\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.738913432030486\\\",\\\"cost_for_two_ctr\\\":\\\"0.33903653853465654\\\",\\\"cost_per_unit\\\":\\\"0.9947598253275108\\\",\\\"distance\\\":\\\"0.8141960467735178\\\",\\\"organic_ctr\\\":\\\"0.6642222841053251\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.09561535309383964\\\"},\\\"search_id\\\":\\\"57b9b697-42d1-4147-9448-3aeffb6fddb5\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.43071597797586864}\",\"subzone_id\":\"0\"}",
            "event_names": {
                "tap": "{\"action\":\"click\"}",
                "impression": "{\"action\":\"impression\"}",
                "served": "{\"action\":\"serve\"}"
            }
        },
        {
            "table_name": "zsearch_events_log",
            "payload": "{\"search_id\":\"57b9b697-42d1-4147-9448-3aeffb6fddb5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20972398\",\"element_type\":\"listing\",\"rank\":11,\"metadata\":{\"is_ad\":\"true\"}}",
            "event_names": {
                "tap": "{\"action\":\"tap\"}",
                "impression": "{\"action\":\"impression\"}"
            }
        }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": false,
    "bulkOffers": [],
    "isDisabled": false,
    "bottomContainers": []
    },
    {
    "type": "restaurant",
    "info": {
        "resId": 19418353,
        "name": "Infinity Cafe",
        "image": {
            "url": "https://b.zmtcdn.com/data/pictures/3/19418353/c9373cbda5152a924df2c41f7b6e873e_featured_v2.jpg",
            "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/19418353/c9373cbda5152a924df2c41f7b6e873e_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
            "url": "https://b.zmtcdn.com/data/pictures/3/19418353/2e5ee61817025adffe4f83d6944c851f_o2_featured_v2.jpg"
        },
        "rating": {
            "has_fake_reviews": 0,
            "aggregate_rating": "3.6",
            "rating_text": "3.6",
            "rating_subtitle": "Good",
            "rating_color": "9ACD32",
            "votes": "136",
            "subtext": "REVIEWS",
            "is_new": false
        },
        "ratingNew": {
            "newlyOpenedObj": null,
            "suspiciousReviewObj": null,
            "ratings": {
                "DINING": {
                    "rating_type": "DINING",
                    "rating": "3.1",
                    "reviewCount": "37",
                    "reviewTextSmall": "37 Reviews",
                    "subtext": "37 Dining Reviews",
                    "color": "#1C1C1C",
                    "ratingV2": "3.1",
                    "subtitle": "DINING",
                    "sideSubTitle": "Dining Ratings",
                    "bgColorV2": {
                        "type": "yellow",
                        "tint": "400"
                    },
                    "newOnDining": false
                },
                "DELIVERY": {
                    "rating_type": "DELIVERY",
                    "rating": "4.0",
                    "reviewCount": "99",
                    "reviewTextSmall": "99 Reviews",
                    "subtext": "99 Delivery Reviews",
                    "color": "#E23744",
                    "ratingV2": "4.0",
                    "subtitle": "DELIVERY",
                    "sideSubTitle": "Delivery Ratings",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "700"
                    },
                    "newOnDelivery": false
                }
            }
        },
        "cft": {
            "text": "₹500 for two"
        },
        "cfo": {
            "text": "₹200 for one"
        },
        "locality": {
            "name": "Ranjit Avenue, Amritsar",
            "address": "Sco 56, B - Block, Ranjit Avenue, Amritsar",
            "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
            "text": "Opens at 9am",
            "color": "#ab000d"
        },
        "cuisine": [
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/cafes/",
                "name": "Cafe"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/italian/",
                "name": "Italian"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/fast-food/",
                "name": "Fast Food"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                "url": "https://www.zomato.com/amritsar/restaurants/beverages/",
                "name": "Beverages"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                "url": "https://www.zomato.com/amritsar/restaurants/burger/",
                "name": "Burger"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyNFwiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/wraps/",
                "name": "Wraps"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/street-food/",
                "name": "Street Food"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/coffee/",
                "name": "Coffee"
            }
        ],
        "should_ban_ugc": false,
        "costText": {
            "text": "₹500 for two"
        }
    },
    "order": [],
    "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
    },
    "takeaway": [],
    "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/infinity-cafe-ranjit-avenue/info",
        "clickActionDeeplink": ""
    },
    "distance": "1.4 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
        {
            "table_name": "zsearch_events_log",
            "payload": "{\"search_id\":\"57b9b697-42d1-4147-9448-3aeffb6fddb5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19418353\",\"element_type\":\"listing\",\"rank\":19}",
            "event_names": {
                "tap": "{\"action\":\"tap\"}",
                "impression": "{\"action\":\"impression\"}"
            }
        }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": false,
    "bulkOffers": [],
    "isDisabled": false,
    "bottomContainers": []
    },
    {
    "type": "restaurant",
    "info": {
        "resId": 19274717,
        "name": "Firangi Dhaba",
        "image": {
            "url": "https://b.zmtcdn.com/data/pictures/7/19274717/92f2f57d402275ddcf4fa1ae651248be_featured_v2.jpg",
            "urlWithParams": "https://b.zmtcdn.com/data/pictures/7/19274717/92f2f57d402275ddcf4fa1ae651248be_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
        },
        "o2FeaturedImage": {
            "url": "https://b.zmtcdn.com/data/pictures/7/19274717/3766ad89560ce747adc3e21a3cf5c21e_o2_featured_v2.jpg"
        },
        "rating": {
            "has_fake_reviews": 0,
            "aggregate_rating": "4.1",
            "rating_text": "4.1",
            "rating_subtitle": "Very Good",
            "rating_color": "5BA829",
            "votes": "1,810",
            "subtext": "REVIEW",
            "is_new": false
        },
        "ratingNew": {
            "newlyOpenedObj": null,
            "suspiciousReviewObj": null,
            "ratings": {
                "DINING": {
                    "rating_type": "DINING",
                    "rating": "4.2",
                    "reviewCount": "211",
                    "reviewTextSmall": "211 Reviews",
                    "subtext": "211 Dining Reviews",
                    "color": "#1C1C1C",
                    "ratingV2": "4.2",
                    "subtitle": "DINING",
                    "sideSubTitle": "Dining Ratings",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "700"
                    },
                    "newOnDining": false
                },
                "DELIVERY": {
                    "rating_type": "DELIVERY",
                    "rating": "3.9",
                    "reviewCount": "1,599",
                    "reviewTextSmall": "1,599 Reviews",
                    "subtext": "1,599 Delivery Reviews",
                    "color": "#E23744",
                    "ratingV2": "3.9",
                    "subtitle": "DELIVERY",
                    "sideSubTitle": "Delivery Ratings",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "600"
                    },
                    "newOnDelivery": false
                }
            }
        },
        "cft": {
            "text": "₹550 for two"
        },
        "cfo": {
            "text": "₹250 for one"
        },
        "locality": {
            "name": "Ranjit Avenue, Amritsar",
            "address": "117, 3rd & 4th Floor, District Shopping Complex, Opposite Municipal Corporation Office, Ranjit Avenue, Amritsar",
            "localityUrl": "amritsar/ranjit-avenue-restaurants"
        },
        "timing": {
            "text": "Opens at 12noon",
            "color": "#ab000d"
        },
        "cuisine": [
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/north-indian/",
                "name": "North Indian"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/chinese/",
                "name": "Chinese"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/rolls/",
                "name": "Rolls"
            },
            {
                "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                "url": "https://www.zomato.com/amritsar/restaurants/pizza/",
                "name": "Pizza"
            }
        ],
        "should_ban_ugc": false,
        "costText": {
            "text": "₹550 for two"
        }
    },
    "order": [],
    "gold": {
        "instant": 10,
        "welcome_offer": false,
        "gold_offer": false,
        "text": "Flat",
        "offerValue": "10% OFF",
        "isGoldIcon": false
    },
    "takeaway": [],
    "cardAction": {
        "text": "",
        "clickUrl": "/amritsar/firangi-dhaba-ranjit-avenue/info",
        "clickActionDeeplink": ""
    },
    "distance": "1.8 km",
    "isPromoted": true,
    "promotedText": "Promoted",
    "trackingData": [
        {
            "table_name": "jadtracking",
            "payload": "{\"banner_id\":\"8977889\",\"bzone\":\"0\",\"campaign_id\":\"17953700\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"22\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"19274717\",\"isNewAd\":\"109\",\"ad_position\":\"18\",\"slider_position\":\"18\",\"slider_sequence\":\"18\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":118,\\\"boosted_rank\\\":18,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.042504\\\",\\\"distance\\\":\\\"1.8692731857299805\\\",\\\"organic_ctr\\\":\\\"0.030303\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"1407\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0\\\",\\\"cost_for_two_ctr\\\":\\\"0.5775850199642022\\\",\\\"cost_per_unit\\\":\\\"1\\\",\\\"distance\\\":\\\"1\\\",\\\"organic_ctr\\\":\\\"1\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.23767293366442\\\"},\\\"search_id\\\":\\\"57b9b697-42d1-4147-9448-3aeffb6fddb5\\\",\\\"section_name\\\":\\\"more\\\",\\\"total_score\\\":0.5521547624854926}\",\"subzone_id\":\"0\"}",
            "event_names": {
                "tap": "{\"action\":\"click\"}",
                "impression": "{\"action\":\"impression\"}",
                "served": "{\"action\":\"serve\"}"
            }
        },
        {
            "table_name": "zsearch_events_log",
            "payload": "{\"search_id\":\"57b9b697-42d1-4147-9448-3aeffb6fddb5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4114430487827578880\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19274717\",\"element_type\":\"listing\",\"rank\":18,\"metadata\":{\"is_ad\":\"true\"}}",
            "event_names": {
                "tap": "{\"action\":\"tap\"}",
                "impression": "{\"action\":\"impression\"}"
            }
        }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": false,
    "bulkOffers": [],
    "isDisabled": false,
    "bottomContainers": []
    }
  ];

  export default resList;